export const USER_ERRORS = {
  FAILED_TO_FETCH_USER: "Failed to fetch user",
  FAILED_TO_UPDATE_USER: "Failed to update user",
  FAILED_TO_VERIFY_EMAIL: "Failed to verify email",
};
